/**
 * Legacy URLs place the service-offer id
 * immediately after the account number, whereas v3 URLs place the module segment
 * there directly (e.g. `/{account}/contacts`).
 */
const SERVICE_OFFER_SEGMENTS = ['all-preferences', 'oncall', 'bulk-order', 'mileage-declarations'];

/**
 * Top-level v3 sidebar segments. Keep in sync with `V3_ROUTES` in `V3Routes.ts`.
 */
export const V3_TOP_SEGMENTS = [
  'home',
  'request-service',
  'liveTrack',
  'main-preferences',
  'tire-wheel',
  'mechanical',
  'contacts',
  'my-admin',
];

/**
 * Segments belonging to the legacy detail/list screens (Contacts, Mechanical,
 * Tire & Wheel) that are reused under the v3 experience.
 */
export const V3_SUB_SEGMENTS = ['mechanical-profile', 'tire-profile', 'wheels', 'wheel-details'];

const V3_PATH_SEGMENTS = [...V3_TOP_SEGMENTS, ...V3_SUB_SEGMENTS];

/**
 * Returns true when the given path belongs to the MSP 3.0 (v3) experience.
 */
export function isV3Path(pathname: string = window.location.pathname): boolean {
  const segments = pathname.split('/').filter(Boolean);
  // segments[0] is the account number when present; the module segment follows it.
  const moduleSegment = segments.length > 1 ? segments[1] : segments[0];
  if (!moduleSegment) return false;
  if (SERVICE_OFFER_SEGMENTS.includes(moduleSegment)) return false;
  return V3_PATH_SEGMENTS.includes(moduleSegment);
}
